import Container from "Components/Container/Container";
import React, { useState, useContext } from "react";
import Input from "form/Inputs/Input";
import useInput from "form/Hooks/user-input";
import Spinner from "Components/RequestHandler/Spinner";
import PasswordInput from "form/Inputs/PasswordInput";
import { Link, useNavigate } from "react-router-dom";
import usePost from "Hooks/usePost";
import { StatusHandler } from "Components/ApiNotification";
import VerificationModal from "Components/Modal/VerificationModal";
import { LoginContext } from "context/Auth/LoginContext";
import { useTranslation } from "react-i18next";

const Login = () => {
  const { setIsLoggedIn, setUser, setIsVerified, setToken } =
    useContext(LoginContext);
  const navigate = useNavigate();
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const { t } = useTranslation();

  const {
    value: emailInput,
    isValid: emailIsValid,
    inputChangeHandler: emailChangeHandler,
  } = useInput(
    (value) =>
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value) &&
      value.trim() !== ""
  );

  const {
    value: passwordInput,
    isValid: passwordIsValid,
    inputChangeHandler: passwordChangeHandler,
  } = useInput(
    (value) =>
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
        value
      ) && value.trim() !== ""
  );

  const handleVerificationLater = () => {
    setShowVerificationModal(false);
    navigate("/");
  };

  const handleVerification = () => {
    navigate("/verify-email", { state: { email: emailInput } });
    setShowVerificationModal(false);
  };

  const { postData, isLoading, isError, data } = usePost();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsClicked(true);

    if (!emailIsValid || !passwordIsValid) return;

    const res = await postData("auth/login", {
      email: emailInput,
      password: passwordInput,
    });

    if (res?.success) {
      const { user, token } = res.data;
      setIsLoggedIn(true);
      setUser(user);
      setToken(token);

      console.log("User logged in successfully:", user);

      if (user.verified) {
        setIsVerified(true);
        navigate("/");
      } else {
        setIsVerified(false);
        setShowVerificationModal(true);
      }
    }
  };

  return (
    <main>
      <Container>
        <div className="my-10 flex flex-col gap-y-4 items-center">
          <h1 className="text-4xl font-medium text-center mys-10 font-title">
            {t("auth.signIn")}
          </h1>
          <StatusHandler error={isError} data={data} />
        </div>

        <form className="lg:w-1/3 mx-auto flex flex-col gap-y-8  font-text ">
          <div className="flex flex-col gap-y-4">
            <Input
              type="email"
              label={t("common.email")}
              value={emailInput}
              onChange={(e) => {
                emailChangeHandler(e);
                setIsClicked(false);
              }}
              hasError={isClicked && !emailIsValid}
              errorMessage={t("auth.emailError")}
            />
            <PasswordInput
              type="password"
              label={t("common.password")}
              value={passwordInput}
              errorMessage={t("auth.passwordError")}
              onChange={(e) => {
                passwordChangeHandler(e);
                setIsClicked(false);
              }}
              hasError={isClicked && !passwordIsValid}
            />
          </div>

          <button
            onClick={handleSubmit}
            className="bg-primary flex items-center justify-center text-white w-full text-center mt-4 text-whiste px-4 py-3 text-2xl uppercase rounded-md"
          >
            {isLoading ? <Spinner isWhite={true} /> : t("auth.signIn")}
          </button>
        </form>
        <div className="flex flex-col lg:flex-row  mt-2 justify-between lg:w-1/3 mx-auto">
          <Link
            to="/forgot-password"
            className="text-center mt-4 text-dark hover:underline"
          >
            {t("common.forgotPassword")}
          </Link>

          <Link
            to="/register"
            className="text-center mt-4 text-dark hover:underline"
          >
            {t("common.dontHaveAccount")}
          </Link>
        </div>
      </Container>
      <VerificationModal
        isOpen={showVerificationModal}
        onClose={handleVerificationLater}
        onVerify={handleVerification}
        email={emailInput}
      />
    </main>
  );
};

export default Login;
